module.exports = __webpack_public_path__ + "img/island-7983688_1280.8f23a2aa.jpg";